// extracted by mini-css-extract-plugin
export default {"base":"FHIRRecordDetails_base__IrmuE","tabs":"FHIRRecordDetails_tabs__v7Gw1","noDetails":"FHIRRecordDetails_noDetails__xfKFY","closeButton":"FHIRRecordDetails_closeButton__ioubA"};